import { styled } from 'styled-components';
import Card from 'react-bootstrap/Card';

const AgeCategory = styled.span`
  padding: 0.25rem 1rem;
  border: 0.063rem solid rgba(226, 229, 241, 1);
  border-radius: 0.5rem;
  font-size: 2rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AvatarPlaceholder = styled.div`
  width: 2rem;
  height: 2rem;
`;

const CardBodyBackground = styled(Card.Body)`
  background-image: url('/assets/img/css/primary-pattern.png');
  background-size: cover;
`;

export { AgeCategory, AvatarPlaceholder, CardBodyBackground };
